import type { IConversation } from './conversation';
import { conversationRecordDbSchemaMap } from './conversation';
import {
  Joi,
  objectSchemaOf,
  makeAllOptional,
  actionCreator,
} from '../helpers';
import { forConversation } from '../channels';

export const UPDATE = 'DIALOGUE/UPDATE';

export const conversationUpdateActionSchema = objectSchemaOf<IConversationUpdateAction>(
  {
    type: Joi.string().required().valid(UPDATE),
    payload: Joi.object(
      makeAllOptional(conversationRecordDbSchemaMap)
    ).required(),
  }
);

export interface IConversationUpdateAction {
  type: typeof UPDATE;
  payload: Partial<IConversation>;
}

export const conversationUpdate = actionCreator({
  type: UPDATE,
  schema: conversationUpdateActionSchema,
  channels: [forConversation],
});
